// This can be used to log further cart types to NR if needed in future instead of creating new extra NR field
export enum CartType {
    IRCTC = "IRCTC",
}
